import React from 'react';

import {makeStyles} from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

const useStyles = makeStyles((theme) => ({
  kibana: {
    marginTop: 5,
    marginLeft: 5,
  },
  kubernetes: {},
  aws: {
    marginLeft: 1,
  },
}));

export const KibanaIcon: React.FC = () => {
  const classes = useStyles({});
  return (
    <SvgIcon className={classes.kibana}>
      <svg>
        <polygon points="12.75 0 0 0 0 14.68 12.75 0" />
        <path d="M7.4,9.37,1.15,16.56l-.53.63H12.51A12.75,12.75,0,0,0,7.4,9.37Z" />
      </svg>
    </SvgIcon>
  );
};

export const KubernetesIcon: React.FC = () => {
  const classes = useStyles({});
  return (
    <SvgIcon className={classes.kubernetes}>
      <path d="M11.4.13a.67.67,0,0,0-.64.71h0a1,1,0,0,0,0,.17,4.07,4.07,0,0,0,.08.61,5.33,5.33,0,0,1,.07,1.16.66.66,0,0,1-.2.33l0,.27a8,8,0,0,0-1.16.18A8.21,8.21,0,0,0,5.35,6l-.23-.16a.48.48,0,0,1-.38,0A6.45,6.45,0,0,1,3.88,5a5.68,5.68,0,0,0-.42-.44l-.14-.12a.8.8,0,0,0-.45-.16.62.62,0,0,0-.51.22.67.67,0,0,0,.16.94h0l.13.11c.18.13.35.2.53.31a5.41,5.41,0,0,1,.95.67.66.66,0,0,1,.13.37l.21.18a8.26,8.26,0,0,0-1.31,5.77l-.27.08a1,1,0,0,1-.27.28,6.55,6.55,0,0,1-1.15.19,4.26,4.26,0,0,0-.61,0l-.17,0h0a.67.67,0,0,0-.54.78.69.69,0,0,0,.83.47H1l.16,0a5,5,0,0,0,.58-.22,6.1,6.1,0,0,1,1.11-.33.7.7,0,0,1,.37.13l.28,0a8.32,8.32,0,0,0,3.69,4.6l-.12.28a.67.67,0,0,1,.06.36,5.92,5.92,0,0,1-.58,1.05A3.77,3.77,0,0,0,6.2,21a1.3,1.3,0,0,0-.08.17.67.67,0,0,0,.27.91.68.68,0,0,0,.88-.36h0a1.19,1.19,0,0,0,.08-.16c.09-.21.12-.38.19-.58A4.42,4.42,0,0,1,8,19.83a.53.53,0,0,1,.28-.14l.14-.26a8.34,8.34,0,0,0,4.81.35,8.24,8.24,0,0,0,1.1-.34l.13.25a.51.51,0,0,1,.33.2A6.94,6.94,0,0,1,15.26,21a4.43,4.43,0,0,0,.18.59,1.3,1.3,0,0,1,.08.17.69.69,0,0,0,.89.36.68.68,0,0,0,.27-.91L16.6,21a5.06,5.06,0,0,0-.35-.51,5.9,5.9,0,0,1-.56-1,.52.52,0,0,1,.05-.38,1.12,1.12,0,0,1-.11-.26,8.29,8.29,0,0,0,3.69-4.64l.27.05a.56.56,0,0,1,.36-.13,6.43,6.43,0,0,1,1.12.33c.19.07.35.16.57.22l.17,0h0a.64.64,0,1,0,.28-1.25l-.18,0c-.23,0-.41,0-.62-.05a5.74,5.74,0,0,1-1.15-.19.65.65,0,0,1-.27-.28l-.26-.07A8.27,8.27,0,0,0,18.3,7.06l.22-.2a.56.56,0,0,1,.12-.37,6.13,6.13,0,0,1,1-.66c.18-.11.35-.18.53-.31l.14-.12a.67.67,0,0,0,.16-.94.69.69,0,0,0-1-.06l-.14.11a5.76,5.76,0,0,0-.42.45,5.91,5.91,0,0,1-.87.78.77.77,0,0,1-.38,0L17.41,6A8.35,8.35,0,0,0,12.1,3.39c0-.08,0-.24,0-.28a.47.47,0,0,1-.21-.32A6,6,0,0,1,12,1.63,6,6,0,0,0,12,1V.84A.67.67,0,0,0,11.4.13Zm-.81,5L10.4,8.44h0A.56.56,0,0,1,9.83,9a.52.52,0,0,1-.33-.11h0l-2.75-2A6.56,6.56,0,0,1,9.91,5.21,5.72,5.72,0,0,1,10.59,5.09Zm1.61,0A6.66,6.66,0,0,1,16,6.94L13.3,8.87h0a.58.58,0,0,1-.78-.1.66.66,0,0,1-.12-.33h0ZM5.74,8.19l2.51,2.25h0a.56.56,0,0,1,.07.78.61.61,0,0,1-.29.19H8l-3.23.93A6.58,6.58,0,0,1,5.74,8.19ZM17,8.19a6.61,6.61,0,0,1,.83,2A6.84,6.84,0,0,1,18,12.35l-3.24-.93v0a.56.56,0,0,1-.4-.67.52.52,0,0,1,.18-.3h0L17,8.19Zm-6.15,2.42h1l.64.8-.23,1-.92.44-.93-.44-.23-1Zm3.3,2.74a.29.29,0,0,1,.13,0h0l3.33.56A6.58,6.58,0,0,1,15,17.26l-1.29-3.12h0A.57.57,0,0,1,14,13.4a.59.59,0,0,1,.22-.05Zm-5.6,0a.57.57,0,0,1,.55.44.6.6,0,0,1,0,.35h0L7.82,17.25a6.66,6.66,0,0,1-2.65-3.33l3.3-.56h.11Zm2.79,1.36a.52.52,0,0,1,.27,0,.58.58,0,0,1,.25.24h0L13.53,18a4.84,4.84,0,0,1-.65.19A6.67,6.67,0,0,1,9.27,18L10.9,15h0A.54.54,0,0,1,11.37,14.72Z" />
    </SvgIcon>
  );
};

export const AwsIcon: React.FC = () => {
  const classes = useStyles({});
  return (
    <SvgIcon className={classes.aws}>
      <path d="M10.85.41.35,6.47V18.59l10.5,6.06,10.5-6.06V6.47ZM20,6.74,10.85,12,1.75,6.74l9.1-5.26Zm-18.68.8,9.11,5.26V23.32L1.28,18.06Zm10,15.78V12.8l9.11-5.26V18.06Z" />
    </SvgIcon>
  );
};
